/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BannedCommunity,
    BannedCommunityFromJSON,
    BannedCommunityFromJSONTyped,
    BannedCommunityToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetBannedCommunitiesResponse
 */
export interface GetBannedCommunitiesResponse {
    /**
     * 
     * @type {Array<BannedCommunity>}
     * @memberof GetBannedCommunitiesResponse
     */
    bannedCommunities: Array<BannedCommunity>;
}

export function GetBannedCommunitiesResponseFromJSON(json: any): GetBannedCommunitiesResponse {
    return GetBannedCommunitiesResponseFromJSONTyped(json, false);
}

export function GetBannedCommunitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBannedCommunitiesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bannedCommunities': ((json['bannedCommunities'] as Array<any>).map(BannedCommunityFromJSON)),
    };
}

export function GetBannedCommunitiesResponseToJSON(value?: GetBannedCommunitiesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bannedCommunities': ((value.bannedCommunities as Array<any>).map(BannedCommunityToJSON)),
    };
}


